import { render, staticRenderFns } from "./UM_userInfo.vue?vue&type=template&id=48e15c52&scoped=true&"
import script from "./UM_userInfo.vue?vue&type=script&lang=js&"
export * from "./UM_userInfo.vue?vue&type=script&lang=js&"
import style0 from "./UM_userInfo.vue?vue&type=style&index=0&id=48e15c52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e15c52",
  null
  
)

export default component.exports